export default {
  "otherGoods.dialogTitle": "その他仕入作成/編集",
  "otherGoods.itemCode": "品目コード",
  "otherGoods.plsEnterItemCode": "品目コードを入力してください",
  "otherGoods.detailedSummary": "詳細/摘要",
  "otherGoods.plsEnterDetailsDescription": "詳細/摘要を入力してください",
};